import React from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';

/**
 * 
 * @returns 
 */
const PropertyCategories = () => {

    let publicUrl = process.env.PUBLIC_URL + '/'

    return (
        <div className="ltn__banner-area pt-120 pb-60 go-top">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="section-title-area ltn__section-title-2--- text-center">
                            <h6 className="section-subtitle section-subtitle-2 ltn__secondary-color">Propriétés</h6>
                            <h2 className="section-title">Biens immobiliers par catégorie</h2>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-8 col-md-6">
                        <div
                            className="ltn__banner-item ltn__banner-style-4 text-color-white bg-image opacity-3 apartment"
                            data-bs-bg={`${publicUrl}assets/img/properties/apartment.jpg`}
                        >
                            <div className="ltn__banner-info">
                                <h3>
                                    <Link to="/appartements">Appartements</Link>
                                </h3>
                                {/* <p> Great Deals Available</p> */}
                                <mark>9 propriétés</mark>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div
                            className="ltn__banner-item ltn__banner-style-4 text-color-white bg-image opacity-5 condo"
                            data-bs-bg={`${publicUrl}assets/img/properties/condo.jpg`}
                        >
                            <div className="ltn__banner-info">
                                <h3>
                                    <Link to="/appartements">Condos</Link>
                                </h3>
                                {/* <p> Great Deals Available</p> */}
                                <mark>4 propriétés</mark>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div
                            className="ltn__banner-item ltn__banner-style-4 text-color-white bg-image opacity-7 house"
                            data-bs-bg={`${publicUrl}assets/img/properties/house.jpg`}
                        >
                            <div className="ltn__banner-info">
                                <h3>
                                    <Link to="/maisons">Maisons</Link>
                                </h3>
                                {/* <p> Great Deals Available</p> */}
                                <mark>2 propriétés</mark>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div
                            className="ltn__banner-item ltn__banner-style-4 text-color-white bg-image opacity-7 locale"
                            data-bs-bg={`${publicUrl}assets/img/properties/locale.jpg`}
                        >
                            <div className="ltn__banner-info">
                                <h3>
                                    <Link to="/locales">Locaux</Link>
                                </h3>
                                {/* <p> Great Deals Available</p> */}
                                <mark>13 propriétés</mark>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div
                            className="ltn__banner-item ltn__banner-style-4 text-color-white bg-image opacity-4 land"
                            data-bs-bg={`${publicUrl}assets/img/properties/land.jpg`}
                        >
                            <div className="ltn__banner-info">
                                <h3>
                                    <Link to="/terrains">Terrains</Link>
                                </h3>
                                {/* <p> Great Deals Available</p> */}
                                <mark>74 propriétés</mark>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PropertyCategories;
